import WebFontLoader from 'webfontloader';

// Async fonts loading
WebFontLoader.load({});
